import axios from 'axios';
import { API_URL, TOKEN_KEY } from '../config';

const api = axios.create({
  baseURL: API_URL,
  headers: { Accept: 'application/json' },
});

// Attach the bearer token on every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401 (expired / missing token) drop the token and bounce to login.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

/**
 * Pull a human message out of a Laravel error response.
 */
export function errorMessage(error, fallback = 'Something went wrong.') {
  const res = error.response;
  if (!res) return 'Cannot reach the API server.';
  if (res.status === 403) return "You don't have permission to do that.";
  if (res.data && res.data.message) return res.data.message;
  return fallback;
}

/**
 * Laravel 422 validation errors -> { field: "first message" }.
 */
export function validationErrors(error) {
  const errs = error.response && error.response.data && error.response.data.errors;
  if (!errs) return {};
  return Object.fromEntries(Object.entries(errs).map(([k, v]) => [k, v[0]]));
}

export default api;
